import { h, Component } from 'preact';
import s from 'components/templates/headline/headline.sss';

export default class Headline extends Component {
	render({data, isDesktop, active}) {

		const { title, description } = data;

		return (
			<div id='headline' class={s.wrapper}>
				<div class={s.container}>
					{title && <h1 class={s.title}>{title}</h1>}
					{description && <p class={s.description}>{description}</p>}
				</div>
			</div>
		);
	}
}
